// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styles from './retailCashbook.scss';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import {
  setDateFilter,
  getCollectionsCashbook,
  getOverallOutstanding,
  filterTableData,
  openHandoverTransactionModal
} from './retailCashbookRedux/retailCashbookActionCreator';
import {
  shouldTableDataBeFetchedForNewDateRange,
  getSelectOptionList,
  getColumnSum,
  jsonToCSVConvertor
} from '../../../services/helpers';
import {
  getOutstandingAmounts,
  retailCashbookTableConfig
} from './retailCashbookHelper';
import SearchBox from '../../commons/searchBox/searchBox';
import DateRangeFilter from '../../commons/dateFilter/dateFilter';
import Select from '../../commons/formElements/select/select';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import Loader from '../../commons/loader/loader';
import AlertsBar from '../../commons/alertsBar/alertsBar';
import ModalWithTable from '../../commons/modalWithTable/modalWithTable';
import Modal from '../../commons/modal/modal';
import DepositSlip from './depositSlip/depositSlip';

type Props = {
  retailCashbookState: Object,
  setPageName: Function,
  setDateFilter: Function,
  getCollectionsCashbook: Function,
  getOverallOutstanding: Function,
  filterTableData: Function,
  openHandoverTransactionModal: Function
};

type State = {
  resetSearchText: boolean,
  searchString: string,
  transactionTypeOptions: Array<any>,
  transactionTypeSelectedOption: string,
  recievedFromOptions: Array<any>,
  recievedFromSelectedOption: string
};

const pageObj = {
  pageName: 'RETAIL CASHBOOK',
  betaPage: false
};

class RetailCashbook extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.selectedComponentKey = 'RTL_CASHBOOK';
    this.handoverTransactionKey = 'RTL_CASHBOOK_TRANSACTION_HANDOVER_KEY';
    this.alertMessage = 'Nothing to show at the moment';
    this.tableActionFunctions = {
      RTL_CASHBOOK: Object.assign(
        {},
        {
          openHandoverTransactionModal: this.props.openHandoverTransactionModal
        }
      )
    };
    this.state = {
      resetSearchText: false,
      showModal: false,
      searchString: null,
      transactionTypeOptions: [
        { key: 'Credit', val: 'Credit' },
        { key: 'Debit', val: 'Debit' }
      ],
      transactionTypeSelectedOption: null,
      recievedFromOptions: [],
      recievedFromSelectedOption: null,
      summaryCards: [
        {
          key: 'Opening Outstanding',
          amount: 0
        },
        {
          key: 'Credits',
          amount: 0
        },
        {
          key: 'Debits',
          amount: 0
        },
        {
          key: 'Closing Outstanding',
          amount: 0
        },
        {
          key: 'Overall Outstanding',
          amount: 0
        }
      ]
    };
    this.cashbookHandoverTransactionModalTheme = {
      name: 'themeGrey',
      titleCenter: false,
      showBackBtn: false,
      closeIcnWhite: false
    };
    this.toggleShowModal = this.toggleShowModal.bind(this);
    this.hideDepositSlip = this.hideDepositSlip.bind(this);
  }

  componentWillMount() {
    this.props.setPageName(pageObj);
  }

  componentWillReceiveProps(nextProps) {
    if (
      shouldTableDataBeFetchedForNewDateRange(
        nextProps.retailCashbookState.filterValues,
        this.props.retailCashbookState.filterValues
      )
    ) {
      if (nextProps.retailCashbookState.filterValues) {
        this.props.getCollectionsCashbook(nextProps.retailCashbookState);
        this.props.getOverallOutstanding(nextProps.retailCashbookState);
      }
    }

    if (nextProps.retailCashbookState.tableData) {
      this.state.recievedFromOptions = getSelectOptionList(
        nextProps.retailCashbookState.tableData,
        'recievedFromName'
      );
    }
  }

  onSearchValueChange(val) {
    // eslint-disable-next-line
    console.log('on search', val);
    this.setState({ searchString: val });
    this.props.filterTableData({
      searchString: val,
      transactionTypeSelectedOption: this.state.transactionTypeSelectedOption,
      recievedFromSelectedOption: this.state.recievedFromSelectedOption
    });
  }

  onTransactionTypeChange(val) {
    // eslint-disable-next-line
    console.log('on onTransactionTypeChange', val);
    this.setState({ transactionTypeSelectedOption: val });
    this.props.filterTableData({
      searchString: this.state.searchString,
      transactionTypeSelectedOption: val,
      recievedFromSelectedOption: this.state.recievedFromSelectedOption
    });
  }

  onRecievedFromChange(val) {
    // eslint-disable-next-line
    console.log('on onRecievedFromChange', val);
    this.setState({ recievedFromSelectedOption: val });
    this.props.filterTableData({
      searchString: this.state.searchString,
      transactionTypeSelectedOption: this.state.transactionTypeSelectedOption,
      recievedFromSelectedOption: val
    });
  }

  onDownloadClick() {
    jsonToCSVConvertor(
      (this.props.retailCashbookState &&
        this.props.retailCashbookState.tableDataFiltered) ||
        [],
      'Retail Cashbook',
      retailCashbookTableConfig.columns
    );
  }

  setSummaryCardAmounts(key: string, value: numeric) {
    this.state.summaryCards.forEach(obj => {
      if (obj.key === key) {
        obj.amount = value;
      }
    });
  }

  summaryFilterFunction(row: Object, filterObj: Object) {
    const filterArrayLength = filterObj.filterColummnKeys.length;

    for (let i = 0; i < filterArrayLength; i += 1) {
      if (filterObj.filterColummnKeys[i] === 'transactionType') {
        if (
          filterObj.filterValues[i] === 'Debit' &&
          row.transactionType === 'CREDIT'
        ) {
          return false;
        } else if (
          filterObj.filterValues[i] === 'Credit' &&
          row.transactionType === 'DEBIT'
        ) {
          return false;
        }
      } else if (
        row[filterObj.filterColummnKeys[i]] !== filterObj.filterValues[i]
      ) {
        return false;
      }
    }

    return true;
  }

  toggleShowModal() {
    this.setState(prevState => ({
      showModal: !prevState.showModal
    }));
  }

  hideDepositSlip(depositType) {
    if (depositType === 'CASH') {
      this.setState({
        showCashDepositSlipPage: false,
        showModal: false
      });
    } else {
      this.setState({
        showChequeDepositSlipPage: false,
        showModal: false
      });
    }
  }

  sortTable(tableData) {
    if (tableData && tableData.length) {
      // If b.transactionTime > a.transactionTime -- sort b to an index lower than a i.e. b comes first
      return tableData.sort((a, b) => b.transactionTime - a.transactionTime);
    }
    return [];
  }

  renderDepositSlipModal() {
    return (
      <Modal
        showModal={this.state.showModal}
        title="Transfer Money"
        closeModal={this.toggleShowModal}
      >
        <div className={`${styles.modalTextPadding} l-row j-center`}>
          Which type of deposit slip you want to create?
        </div>
        <div className="l-row">
          <button
            onClick={() => {
              this.setState({
                showCashDepositSlipPage: true
              });
            }}
            className={`j-left action-button ${styles.depositActionButtons} ${styles.buttonMargin}`}
          >
            Cash
          </button>
          <button
            onClick={() => {
              this.setState({
                showChequeDepositSlipPage: true
              });
            }}
            className={`j-left action-button ${styles.depositActionButtons} ${styles.buttonMargin}`}
          >
            Cheque
          </button>
        </div>
      </Modal>
    );
  }

  renderRetailCashbook() {
    const {
      isLoading,
      tableData,
      tableDataFiltered,
      handoverTransactionTableData,
      overallOutstanding
    } = this.props.retailCashbookState;
    const tableDataLength =
      tableDataFiltered !== null ? tableDataFiltered.length : 0;
    const outstandingCollection = getOutstandingAmounts(tableData);
    const handoverTransactionModalTitle = handoverTransactionTableData
      ? `Handover Transaction ID : ${handoverTransactionTableData.transactionId}`
      : '';
    if (outstandingCollection) {
      this.setSummaryCardAmounts(
        'Closing Outstanding',
        outstandingCollection.closingOutstanding
      );
      this.setSummaryCardAmounts(
        'Opening Outstanding',
        outstandingCollection.openingOutstanding
      );
      this.setSummaryCardAmounts('Overall Outstanding', overallOutstanding);
    }
    const creditCollection = getColumnSum(
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['transactionType'],
        filterValues: ['Credit']
      },
      this.summaryFilterFunction
    );
    this.setSummaryCardAmounts('Credits', creditCollection);
    const debitCollection = getColumnSum(
      tableDataFiltered,
      'totalAmount',
      {
        filterColummnKeys: ['transactionType'],
        filterValues: ['Debit']
      },
      this.summaryFilterFunction
    );
    this.setSummaryCardAmounts('Debits', debitCollection);
    return (
      <div className={`${styles.retailCashbookWrapper}`}>
        <div className={`${styles.filterPanelParent} l-row a-center`}>
          <div className={`${styles.filterPanelLeft} l-row flex-70`}>
            <div className={`${styles.filterLabel} l-row a-center`}>
              Filter By:
            </div>
            <div className={`${styles.filterComponentWrapper}`}>
              <DateRangeFilter
                setDateFilter={this.props.setDateFilter}
                displayFormat="DD MMM YY"
                isOutsideRangeCheck={true}
              />
            </div>
            <div className={`${styles.filterComponentWrapper}`}>
              <Select
                label="Transaction Type"
                optionsArrOfObj={this.state.transactionTypeOptions}
                onSelect={val => {
                  this.onTransactionTypeChange(val);
                }}
              />
            </div>
            <div className={`${styles.filterComponentWrapper}`}>
              <Select
                label="Recieved From"
                optionsArrOfObj={this.state.recievedFromOptions}
                onSelect={val => {
                  this.onRecievedFromChange(val);
                }}
              />
            </div>
            <div
              className={`action-button-wrapper ${styles.download}`}
              onClick={() => this.onDownloadClick()}
            >
              <div className="action-button">Download</div>
            </div>
          </div>
          <div className={`${styles.filterPanelRight} l-row flex-30 j-end`}>
            <div className={`${styles.filterComponentWrapper}`}>
              <div className=" action-button-wrapper">
                <button
                  className={`action-button ${styles.depositActionButtons}`}
                  onClick={this.toggleShowModal}
                >
                  Create deposit slip
                </button>
                {this.renderDepositSlipModal()}
              </div>
            </div>
            <div className={`${styles.filterComponentWrapper}`}>
              <SearchBox
                onSearchValueChange={val => this.onSearchValueChange(val)}
                resetSearchText={this.state.resetSearchText}
              />
            </div>
          </div>
        </div>

        <div className={`${styles.summaryCardParent} l-row`}>
          {this.state.summaryCards.map((summaryCard, index) => (
            <div key={index} className={`${styles.summaryCard} l-col j-center`}>
              <div className={`${styles.totalAmount}`}>
                &#8377;{Math.round(summaryCard.amount * 100) / 100}
              </div>
              <div className={`${styles.totalAmountTag}`}>
                {' '}
                {summaryCard.key}{' '}
              </div>
            </div>
          ))}
        </div>

        <div className={`${styles.modalParent}`}>
          {tableDataFiltered && tableDataFiltered.length ? (
            <ModalWithTable
              showModal={
                !!this.props.retailCashbookState.showHandoverTransactionModal
              }
              closeModal={val => this.props.openHandoverTransactionModal(val)}
              tableKey={this.handoverTransactionKey}
              modalTheme={this.cashbookHandoverTransactionModalTheme}
              tableData={
                handoverTransactionTableData &&
                handoverTransactionTableData.handoverConsignments &&
                handoverTransactionTableData.handoverConsignments.length
                  ? handoverTransactionTableData.handoverConsignments
                  : []
              }
              title={handoverTransactionModalTitle}
            />
          ) : (
            ''
          )}
        </div>

        <div className={`${styles.tableWrapper}`}>
          {isLoading ? <Loader /> : ''}
          {!isLoading && tableData && tableData.length ? (
            <ZoomTable
              configKey={this.selectedComponentKey}
              tableDataLength={tableDataLength}
              tableData={this.sortTable(tableDataFiltered)}
              actionFunctions={
                this.tableActionFunctions[this.selectedComponentKey]
              }
            />
          ) : (
            <AlertsBar message={this.alertMessage} loading={isLoading} />
          )}
        </div>
      </div>
    );
  }

  renderDepositSlip() {
    if (this.state.showCashDepositSlipPage) {
      return (
        <DepositSlip
          key="cash"
          depositType="CASH"
          onBackClick={this.hideDepositSlip}
        />
      );
    }
    return (
      <DepositSlip
        key="cheque"
        depositType="CHEQUE"
        onBackClick={this.hideDepositSlip}
      />
    );
  }

  render() {
    if (
      this.state.showCashDepositSlipPage ||
      this.state.showChequeDepositSlipPage
    ) {
      return this.renderDepositSlip();
    }
    return this.renderRetailCashbook();
  }
}

const mapStateToProps = state => ({
  retailCashbookState: state.retailCashbookState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  setDateFilter: bindActionCreators(setDateFilter, dispatch),
  getCollectionsCashbook: bindActionCreators(getCollectionsCashbook, dispatch),
  getOverallOutstanding: bindActionCreators(getOverallOutstanding, dispatch),
  filterTableData: bindActionCreators(filterTableData, dispatch),
  openHandoverTransactionModal: bindActionCreators(
    openHandoverTransactionModal,
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailCashbook);
